import axios from 'axios'

const client = axios.create({
  baseURL: '/api/Reports',
  json: true
})

export default {
    async execute (vue, method, resource, data) {
        return client({
            method,
            url: resource,
            data
        }).then(req => {
            if (req.data.error){
                vue.$alert(req.data.error);
            }
            return req.data
        })
    },
    get (vue, id) {
        return this.execute(vue, 'get', `Get/${id}`)
    },
    download (vue, data) {
        return this.execute(vue, 'post', 'Download/', data)
    }
}
